<script>
  import PageHero from '$lib/page/Hero.svelte';
  import OtherPagePromo from '$lib/default/OtherPagePromo.svelte';
  import Attachments from '$lib/default/attachments/Index.svelte';
  import Back from '$lib/singlePortfolio/Back.svelte';
  import Seo from '$lib/Seo.svelte';
  import Faq from '$lib/faq/Index.svelte';
  import EntryContent from '$lib/EntryContent.svelte';

  export let page_hero;
  export let blocks;
  export let pageInfo;
  export let attachments;
  export let back;
  export let seo;
  export let faq;
</script>

{#if page_hero}
  <PageHero hero={page_hero} />
{/if}
<div class="container container--medium">
  {#if blocks}
    <EntryContent {blocks} />
  {/if}
  {#if attachments}
    <Attachments {attachments} />
  {/if}
  {#if pageInfo}
    <OtherPagePromo {pageInfo} />
  {/if}
</div>
{#if back}
  <Back {back} />
{/if}

{#if seo}
  <Seo {seo} />
{/if}
{#if faq}
  <Faq {faq} />
{/if}
